export default __webpack_public_path__ + "static/media/pantry2-before2-1440w.571b60c8.webp";